import React, {useState, useEffect} from 'react'
import * as txApi from '../clients/tx-sls-client'

export const useUserTimezone = (role) => {
    const [tourney_countdown, setUpcomingCountDown] = useState([])

    useEffect(() => {

        if(tourney_countdown !== role){
           
            txApi.getUpComingTourneyCountdown()
            .then( result_upcoming_tourney => {
                setUpcomingCountDown(result_upcoming_tourney)
                console.log('result_upcoming_tourney OUTPUT:::',result_upcoming_tourney );
            })
            .catch(error => console.error(`Error retrieving upcoming tournament countdown`))
        }

    },[]);

    return tourney_countdown;
}